import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { WebsiteMode } from '@sb/library/base';

@Directive({
    selector: '[websiteBlockImage]',
    exportAs: 'websiteBlockImage'
})
export class WebsiteBlockImageDirective {
    @Input() websiteMode: WebsiteMode = WebsiteMode.ReadOnly;

    private _showActionMenu: boolean = false;
    private _nativeElement!: HTMLElement;
    private _scrollContainers!: HTMLElement[];

    constructor(private _elementRef: ElementRef) {
    }

    ngOnInit() {
        if (this.websiteMode === WebsiteMode.Preview) {
            this._nativeElement = this._elementRef.nativeElement;
            this.GetScrollContainers(this._nativeElement);
        }
    }

    private GetScrollContainers(element: HTMLElement | null) {
        this._scrollContainers = [];

        while (element) {
            if (element.scrollHeight > element.clientHeight) {
                this._scrollContainers.push(element);
            }
            element = element.parentElement;
        }
    }

    private ScrollIntoView() {
        const rect = this._nativeElement.getBoundingClientRect();
        const offsetTop = rect.top - 150;
        const offsetBottom = rect.bottom - window.innerHeight + 50;

        if (offsetTop < 0) {
            if (this._scrollContainers.length) {
                this._scrollContainers.forEach(container => container.scrollBy({ top: offsetTop, behavior: 'smooth' }));
            } else {
                this._nativeElement.scrollIntoView({ block: 'start', behavior: 'smooth'});
            }
        } else if (offsetBottom > 0) {
            if (this._scrollContainers.length) {
                this._scrollContainers.forEach(container => container.scrollBy({ top: offsetBottom, behavior: 'smooth' }));
            } else {
                this._nativeElement.scrollIntoView({ block: 'end', behavior: 'smooth'});
            }
        }
    }

    get showActionMenu(): boolean {
        return this.websiteMode == WebsiteMode.Preview && this._showActionMenu;
    }

    @HostListener('click') onClickAutoScroll() {
        if (this.websiteMode === WebsiteMode.Preview) {
            this.ScrollIntoView();
        }
    }

    @HostListener('mouseenter') onEnter() {
        this._showActionMenu = true;
    }

    @HostListener('mouseleave') onLeave() {
        this._showActionMenu = false;
    }
}
